import {
  endOfDay,
  getHours,
  getMinutes,
  isSameDay,
  isSameHour,
  setHours,
  setMilliseconds,
  setMinutes,
  setSeconds,
  startOfDay,
  subDays,
} from "../date/date";
import {divide, floor, multiply, round} from "mathjs";
import {ONE_HOUR_IN_MILLIS, ONE_MINUTE_IN_MILLIS} from "./constants";
import {range} from "./util";

export const getNextQuarterHour = (date: Date | number = new Date()): Date => {
  let value: Date = new Date(date);
  value = setSeconds(value, 0);
  value = setMilliseconds(value, 0);

  let addHour = false;
  const hour = getHours(value);
  let minute = getMinutes(value);

  if (minute >= 0 && minute < 15) {
    minute = 15;
  } else if (minute >= 15 && minute < 30) {
    minute = 30;
  } else if (minute >= 30 && minute < 45) {
    minute = 45;
  } else {
    minute = 0;
    addHour = true;
  }

  value = setMinutes(value, minute);
  if (addHour) {
    value = setHours(value, hour + 1);
  }

  return value;
};

/**
 * Returns difference in the dates in minutes.
 *
 * @param to
 * @param from
 */
export const diffInMinutes = (to: Date, from: Date): number => {
  let diff = (from.getTime() - to.getTime()) / 1000;
  diff /= 60;
  return diff;
};

/**
 * Return true if date should be disabled.
 */
export const disabledDateOnlyFuture = (current: Date | undefined | null) => {
  if (!current) {
    return true;
  }

  // Can not select days before today
  return current < startOfDay(new Date());
};

/**
 * Return time of days that should be disabled.
 */
export const disabledDateTimeOnlyFuture = (
  current: Date | undefined | null
) => {
  // Can't select previous hours or minutes of the day of
  const date = new Date();
  const currentHour = getHours(date);
  const currentMinute = getMinutes(date);

  let disabledHours: () => number[] = () => [];
  let disabledMinutes: () => number[] = () => [];

  if (current) {
    const sameDay = isSameDay(current, date);
    const sameHour = isSameHour(current, date);

    if (sameDay) {
      disabledHours = () => range(0, 24).splice(0, currentHour);
    }

    if (sameHour) {
      disabledMinutes = () => range(0, currentMinute);
    }
  } else {
    disabledHours = () => range(0, 24).splice(0, currentHour);
    disabledMinutes = () => range(0, currentMinute);
  }

  return { disabledHours, disabledMinutes };
};

export const toDurationString = (millis: number): string => {
  let duration = '';

  let hours = 0;
  let minutes = 0;
  let isMinus = false;

  let correctedMillis = millis;
  if (millis < 0) {
    correctedMillis = Math.abs(millis);
    isMinus = true;
  }

  hours = divide(correctedMillis, ONE_HOUR_IN_MILLIS);
  hours = floor(hours);

  const hoursInMillis = multiply(hours, ONE_HOUR_IN_MILLIS);

  minutes = divide(millis - hoursInMillis, ONE_MINUTE_IN_MILLIS);
  minutes = round(minutes);

  if (minutes >= 60) {
    hours++;
    minutes = 0;
  }

  if (isMinus) {
    duration += '-';
  }

  if (hours < 10) {
    duration += '0';
  }

  duration += hours;
  duration += ':';

  if (minutes < 10) {
    duration += '0';
  }

  duration += minutes;

  return duration;
};

export const convertDateToUTC = (date: Date) => {
  return new Date(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds()
  );
};

export const isInDttmRange = (dttm: number, from?: number, to?: number): boolean => {
  if (typeof from !== "undefined" && dttm < from) {
    return false;
  }
  if (typeof to !== "undefined" && dttm > to) {
    return false;
  }
  return true;
  }

export const rangeLastNDays = (days: number, now: Date) => {
  const to = endOfDay(now);
  const from = startOfDay(subDays(now, days - 1));
  return {
    from: from,
    to: to,
  };
};
